import Title from './title'

export default Title;